import _ from 'lodash';

import SearchQuery from 'models/search/search_query';
import SearchQueryConverter from 'scripts/application/dto_converters/search/search_query_converter';
import SnippetSearchResult from 'models/search/snippet_search_result';

const RESULTS_SIZE = 50;
// Elasticsearch rejects deep pagination once `from + size` exceeds this cap with a
// SearchOffsetTooLargeError, so stop requesting before we reach it.
const MAX_SEARCH_OFFSET = 10000;

export default class LoadMoreAnswerSearchResults {
  constructor(context) {
    this.context = context;
  }

  run() {
    const answerPanel = this.context.stores.answerPanel.get();
    const searchResult = answerPanel.searchResult;
    if (!searchResult || searchResult.isLoading || searchResult.isLoadingMore) return;

    const hits = searchResult.hits || [];
    const total = _.get(searchResult, 'aggregations.types.total');
    if (_.isNumber(total) && hits.length >= total) return;
    if (hits.length + RESULTS_SIZE > MAX_SEARCH_OFFSET) return;

    answerPanel.setSearchResult(SnippetSearchResult.fromJs({ ...searchResult.toJs(), isLoadingMore: true }));
    this.context.stores.answerPanel.set(answerPanel);

    // `from` is the running hit count, not a raw ES offset; overlap at the page boundary is deduped on append.
    const nextQuery = SearchQuery.fromJs({ ...searchResult.query.toJs(), from: hits.length });
    const queryDto = { query: SearchQueryConverter.toDto(nextQuery) };
    this.context.gateways.snippetSearchResultHttp.request(searchResult.id, queryDto);
  }
}
